import React, { useState } from "react";
import Toggle from "react-toggle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { doRequest } from "../utils/helper";
import Sidebar from "../components/Sidebar";

export default function VariantFaqEdit() {
  let history = useNavigate();
  let location = useLocation();
  let state = location?.state;
  const [tofuIsReady, setTofuIsReady] = useState(
    state?.status === "active" ? true : false
  );
  const [question, setQuestion] = useState(
    state?.question ? state?.question : ""
  );
  const [answer, setAnswer] = useState(state?.answer ? state?.answer : "");
  const [sequence, setSequence] = useState(
    state?.sequence ? state?.sequence : "1"
  );
  const handleTofuChange = () => {
    setTofuIsReady(!tofuIsReady);
  };

  const saveFaqApi = async () => {
    try {
      let data = {
        question: question,
        answer: answer,
        sequence: sequence,
      };
      let res = await doRequest(data, "POST", "faq/save");
      if (+res?.resultFlag === 1) {
      } else {
      }
    } catch (error) {}
  };

  const updateFaqApi = async () => {
    try {
      let data = {
        id: state?.id,
        body: {
          question: question,
          answer: answer,
          sequence: sequence,
          status: tofuIsReady == false ? "inactive" : "active",
        },
      };
      let res = await doRequest(data, "POST", "faq/update");
      if (+res?.resultFlag === 1) {
      } else {
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="container-fluid main">
        <Sidebar />
        <section className="home">
          <div className="container-fluid">
            <div className="searcmain_pad">
              <div className="search_header">
                <ul className="search_list">
                  <li>
                    <h3>Teedex FAQs</h3>
                  </li>

                  <li>
                    <div className="cansear_div">
                      <button
                        className="can_sea"
                        onClick={() => {
                          history("/varintfaq");
                        }}
                      >
                        Cancel
                      </button>
                      {state?.id ? (
                        <button
                          className="sav_sea"
                          onClick={() => {
                            updateFaqApi();
                          }}
                        >
                          Update
                        </button>
                      ) : (
                        <button
                          className="sav_sea"
                          onClick={() => {
                            saveFaqApi();
                          }}
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </li>
                </ul>
              </div>

              <div className="container">
                <div className="varinatfaqsta_pad">
                  <div className="row">
                    <div className="col-sm-1">
                      <Link to="">
                        <img src={"/assets/images/backarrow.svg"} alt="" />
                      </Link>
                    </div>

                    <div className="col-sm-11">
                      <div className="varint_edt_label">
                        <h5>Status</h5>

                        <div className="var_edit_toggle">
                          {tofuIsReady ? <h6>Active</h6> : <h6>Inactive</h6>}
                          <Toggle
                            defaultChecked={tofuIsReady}
                            icons={false}
                            onChange={handleTofuChange}
                          />
                        </div>
                      </div>

                      <div className="var_edit_input">
                        <h6>Question</h6>
                        <div className="var_faqinput">
                          <input
                            type="text"
                            placeholder="Type question here…"
                            onChange={(e) => setQuestion(e.target.value)}
                            value={question}
                          />
                          <p>{question.length}/40</p>
                        </div>
                      </div>

                      <div className="var_edit_input">
                        <h6>Answer</h6>
                        <div className="var_faqinput">
                          <input
                            type="text"
                            placeholder="Type answer here…"
                            onChange={(e) => setAnswer(e.target.value)}
                            value={answer}
                          />
                          <p>{answer.length}/40</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
